/* eslint-disable */
import { ASession } from '../../common/ASession';
import { CustomerType, MembershipTier } from '../FbbEnum';
import * as log from '../../../common/js/appLogger';

export enum IDType {
	hkid = 'hkid',
	passport = 'passport', // not use
}

export class UserProfileSimple extends ASession {
	protected sessionKey: string = 'UserProfileSimple';

	protected customerType: CustomerType = CustomerType.MASS;
	protected membershipTier: MembershipTier = MembershipTier.NONE;
	protected msisdn: string = '';
	protected idType: IDType = IDType.hkid;
	protected hkid4Digits: string = '';

	protected getData() {
		return {
			customerType: this.customerType,
			membershipTier: this.membershipTier,
			idType: this.idType,
			hkid4Digits: this.hkid4Digits,
			msisdn: this.msisdn,
		};
	}
	protected setData(data: any) {
		this.customerType = data.customerType ?? CustomerType.MASS;
		this.msisdn = data.msisdn ?? '';
		var idType = data.idType ?? '';
		if (idType == 'I') {
			idType = 'hkid';
		}
		this.idType = idType ?? IDType.hkid;
		this.hkid4Digits = data.hkid4Digits ?? '';
		this.membershipTier = data.membershipTier ?? MembershipTier.NONE;
	}

	public replaceData(p: UserProfileSimple) {
		this.setData(p.getData());
	}

	protected getDefaultData() {
		return {
			customerType: CustomerType.MASS,
			membershipTier: MembershipTier.NONE,
			idType: IDType.hkid,
			msisdn: '',
			hkid4Digits: '',
		};
	}

	getCustomerType(): CustomerType {
		return this.customerType;
	}

	getMembershipTier(): MembershipTier {
		return this.membershipTier;
	}

	public printUserProfileSimple() {
		var p = {
			customerType: this.customerType,
			membershipTier: this.membershipTier,
			idType: this.idType,
			hkid4Digits: this.hkid4Digits,
			msisdn: this.msisdn,
		};
		log.dot('user Profile', p);
	}

	public getMsisdn(): string {
		return this.msisdn + '';
	}

	public getHkid4Digits(): string {
		return this.hkid4Digits + '';
	}

	public getIdType(): IDType {
		return this.idType;
	}

	public setIdType(idStr: string) {
		if (idStr == 'I' || idStr == 'hkid') {
			this.idType = IDType.hkid;
		} else {
			this.idType = IDType.passport;
		}
	}
}
